import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "absolute top-0 right-0 mt-4 mr-5" };
const _hoisted_2 = { class: "flex items-center" };
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.action_items.edit')
};
import { computed, ref } from 'vue';
import { storeToRefs } from 'pinia';
import { useRetroStore } from '@/pinia_stores/retro';
import ActionItemOwnerAvatars from '@/components/action_items/ActionItemOwnerAvatars.vue';
import ActionItemOwnersText from '@/components/action_items/ActionItemOwnersText.vue';
import ActionItemTemplate from '@/components/action_items/ActionItemTemplate.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'EditActionItemByOther',
    props: {
        item: null
    },
    setup(__props) {
        const props = __props;
        const retroStore = useRetroStore();
        const { actionItemRealtimeValue, isModerator, userWritingActionItem } = storeToRefs(retroStore);
        const { forceExistingActionItemCancellation, forceActionItemEdition } = retroStore;
        const showContextMenu = ref(false);
        const withDescription = computed(() => actionItemRealtimeValue.value !== '');
        function handleForceSubmit() {
            showContextMenu.value = false;
            if (withDescription.value) {
                forceActionItemEdition({
                    itemId: props.item.id,
                    description: actionItemRealtimeValue.value
                });
            }
            else {
                forceExistingActionItemCancellation(props.item.id);
            }
        }
        return (_ctx, _cache) => {
            const _component_user_entered_text = _resolveComponent("user-entered-text");
            const _component_avatar = _resolveComponent("avatar");
            const _directive_click_outside = _resolveDirective("click-outside");
            return (_openBlock(), _createBlock(ActionItemTemplate, {
                title: _ctx.$t('title')
            }, _createSlots({
                ownerAvatars: _withCtx(() => [
                    _createVNode(ActionItemOwnerAvatars, { item: __props.item }, null, 8, ["item"])
                ]),
                ownersText: _withCtx(() => [
                    _createVNode(ActionItemOwnersText, { item: __props.item }, null, 8, ["item"])
                ]),
                body: _withCtx(() => [
                    _createVNode(_component_user_entered_text, { text: _unref(actionItemRealtimeValue) }, null, 8, ["text"])
                ]),
                footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                        _createVNode(_component_avatar, {
                            user: _unref(userWritingActionItem),
                            size: "sm",
                            class: "mr-1"
                        }, null, 8, ["user"]),
                        _createTextVNode(" " + _toDisplayString(_ctx.$t('x_is_editing', { name: _unref(userWritingActionItem).name })), 1)
                    ])
                ]),
                _: 2
            }, [
                (_unref(isModerator))
                    ? {
                        name: "buttons",
                        fn: _withCtx(() => [
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("button", {
                                    class: "text-primary-500 hover:text-primary-400",
                                    onClick: _cache[0] || (_cache[0] = ($event) => (showContextMenu.value = !showContextMenu.value))
                                }, " ... "),
                                (showContextMenu.value)
                                    ? (_openBlock(), _createElementBlock("button", {
                                        key: 0,
                                        class: "absolute top-0 right-0 px-2 py-1 mt-6 -mr-1 text-sm bg-white border border-gray-300 whitespace-nowrap hover:bg-gray-200 text-primary-900",
                                        onClick: handleForceSubmit
                                    }, _toDisplayString(_unref(withDescription) ? _ctx.$t('force_submit') : _ctx.$t('force_cancel')), 1))
                                    : _createCommentVNode("", true)
                            ])), [
                                [_directive_click_outside, () => (showContextMenu.value = false)]
                            ])
                        ])
                    }
                    : undefined
            ]), 1032, ["title"]));
        };
    }
});
